export default __webpack_public_path__ + "static/card_list-0172376d7e60bea213e53039242e7d21.png";